import React from 'react';
import PropTypes from 'prop-types';

import { AnswerButton, AnswerText, SelectionControl } from './styled';

export default function QuizAnswerOption({ label, multiple = false, onSelect, selected = false }) {
  return (
    <AnswerButton
      type="button"
      $selected={selected}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <SelectionControl $multiple={multiple} $selected={selected} aria-hidden="true" />
      <AnswerText>{label}</AnswerText>
    </AnswerButton>
  );
}

QuizAnswerOption.propTypes = {
  label: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};
